import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "export-list-loading"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "export-list-header" }
const _hoisted_5 = { class: "export-list-header__title" }
const _hoisted_6 = { class: "export-list-container" }
const _hoisted_7 = { class: "no-more-container" }
const _hoisted_8 = { class: "no-more-content" }
const _hoisted_9 = {
  key: 1,
  class: "export-no-result"
}
const _hoisted_10 = { class: "export-no-result__text" }
const _hoisted_11 = { class: "export-no-result__title" }

import { ref, inject, onMounted, onUnmounted } from 'vue';
import type { Translator } from 'types/injects/translator.type';
import type { PushToast } from 'types/injects/pushToast.type';
import type { ExportItem as ExportItemType } from 'api/notification/Export';
import ExportItem from 'vcomponents/notifications/ExportItem.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import ExportApi from 'api/notification/Export';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportsList',
  setup(__props) {

const $t = inject('$t') as Translator;
const $pushToast = inject('$pushToast') as PushToast;

const exports = ref<ExportItemType[]>([]);
const isFirstLoading = ref(false);

const exportProgressChange = async ({ id }: { id: string }): Promise<void> => {
    const index = exports.value.findIndex((exportItem) => exportItem.id === id);
    if (index !== -1) {
        const response = await ExportApi.getExport(id);
        exports.value[index] = response.data;
    }
};

const getExports = async () => {
    try {
        isFirstLoading.value = true;
        const response = await ExportApi.getExports({});
        exports.value = response.data.data.filter(function (exportItem) {
            if (exportItem.status === 'succeed' && exportItem.public_url) {
                return true;
            }
            if (moment(exportItem.started_at).add(1, 'days').isAfter(moment())) {
                return true;
            }
            return false;
        });
    } catch {
        $pushToast({
            type: CompassEnums.ToastType.ERROR,
            icon: true,
            text: $t.__('export.notifications.fetchError'),
        });
    } finally {
        isFirstLoading.value = false;
    }
};

const goToExportsPage = () => {
    window.location.href = '/settings/exports';
};

onMounted(async () => {
    await getExports();
    EventBus.on('export:progress', exportProgressChange as (...args: unknown[]) => void);
});

onUnmounted(() => {
    EventBus.off('export:progress', exportProgressChange as (...args: unknown[]) => void);
});

return (_ctx: any,_cache: any) => {
  const _component_CompassButton = _resolveComponent("CompassButton")!

  return (isFirstLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Preloader, { display: true })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (exports.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.$filters.upperCase(_unref($t).__('export.notifications.recentExports'))), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exports.value, (item) => {
                  return (_openBlock(), _createBlock(ExportItem, {
                    key: item.id,
                    item: item
                  }, null, 8 /* PROPS */, ["item"]))
                }), 128 /* KEYED_FRAGMENT */)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_CompassButton, {
                      label: _unref($t).__('export.notifications.viewAll'),
                      type: _ctx.CompassEnums.ButtonType.SECONDARY,
                      size: _ctx.CompassEnums.ButtonSize.MEDIUM,
                      onClick: _withModifiers(goToExportsPage, ["prevent"])
                    }, null, 8 /* PROPS */, ["label", "type", "size"])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                src: "/ressources/logged/img/illustrations/no-results.svg",
                alt: "",
                width: "184",
                height: "184"
              }, null, -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h4", _hoisted_11, _toDisplayString(_unref($t).__('export.notifications.noRecentExports')), 1 /* TEXT */),
                _createVNode(_component_CompassButton, {
                  label: _unref($t).__('export.notifications.viewAll'),
                  type: _ctx.CompassEnums.ButtonType.SECONDARY,
                  size: _ctx.CompassEnums.ButtonSize.MEDIUM,
                  onClick: _withModifiers(goToExportsPage, ["prevent"])
                }, null, 8 /* PROPS */, ["label", "type", "size"])
              ])
            ]))
      ]))
}
}

})